import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../store/ThemeContext";

const VerificationNavbar = ({
  activeSection,
  handleSectionChange,
  customCss = "",
}) => {
  const { t } = useTranslation();
  const { verificationMethods } = useTheme();

  const hasWithQr =
    verificationMethods && Array.isArray(verificationMethods.with_qr)
      ? verificationMethods.with_qr.length > 0
      : false;
  const hasWithoutQr =
    verificationMethods && Array.isArray(verificationMethods.without_qr)
      ? verificationMethods.without_qr.length > 0
      : false;

  return (
    <nav
      className={`w-full flex items-center gap-4 justify-between mb-3 bg-cfPrimary py-1 px-1 rounded-xl ${customCss}`}
    >
      {hasWithQr && (
        <button
          id="verification-navbar-with-qr-button"
          className={`w-full flex-1 focus:outline-none font-semibold py-2 rounded-md transition-all duration-300 ${
            activeSection === "vc"
              ? "bg-white text-cfPrimary cursor-not-allowed"
              : "bg-cfPrimary text-white hover:bg-[#2a2c9a]"
          }`}
          onClick={() => handleSectionChange("vc")}
          disabled={activeSection === "vc"}
        >
          <div className="w-full flex gap-2 justify-center items-center">
            <svg
              className={`h-[1.5rem] w-[1.5rem] ${
                activeSection === "vc" ? "text-cfPrimary" : "text-white"
              }`}
              viewBox="0 0 48 48"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 5H26V26H5V5ZM9 9V22H22V9H9ZM30 5H43V18H30V5ZM34 9V14H39V9H34ZM12 12H19V19H12V12ZM37 22H43V26H37V22ZM5 30H18V43H5V30ZM30 22H34V26H30V22ZM9 34V39H14V34H9ZM30 30H43V43H30V30ZM34 34V39H39V34H34ZM22 34V30H26V34H22ZM22 43V37H26V43H22Z"
              />
            </svg>
            <div>{t("verify:with_qr_code")}</div>
          </div>
        </button>
      )}

      {hasWithoutQr && (
        <button
          id="verification-navbar-without-qr-button"
          className={`w-full flex-1 focus:outline-none font-semibold py-2 rounded-md transition-all duration-300 ${
            activeSection === "legacy"
              ? "bg-white text-cfPrimary cursor-not-allowed"
              : "bg-cfPrimary text-white hover:bg-[#2a2c9a]"
          }`}
          onClick={() => handleSectionChange("legacy")}
          disabled={activeSection === "legacy"}
        >
          <div className="w-full flex gap-2 justify-center items-center">
            <svg
              className={`h-[1.5rem] w-[1.5rem] ${
                activeSection === "legacy" ? "text-cfPrimary" : "text-white"
              }`}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8M14 2L20 8M14 2V8H20M16 13H8M16 17H8M10 9H8"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div>{t("verify:without_qr_code")}</div>
          </div>
        </button>
      )}
    </nav>
  );
};

export default VerificationNavbar;
